import React from 'react';

import cn from 'classnames';

import useStyles from './styles';

const Flipper = ({ children, wrapperClass }) => {
  const classes = useStyles();

  return (
    <div className={cn(classes.scene, wrapperClass)}>
      <div className={classes.flipper}>
        {children}
      </div>
    </div>
  );
};

export default Flipper;
